import server from './server'

export const getRecheckHotelRates = (payload) => {
  return server.get('/hotel_beds/hotels/check_rates', {
    params: payload
  })
}
